import { Box, BoxProps } from '../Box';

export const ModalBody = ({ css, ...rest }: BoxProps) => (
  <Box css={{ gridArea: 'body', overflow: 'auto', ...css }} {...rest} />
);
